import Vue from 'vue';
import {
  alignForNumber,
  formatNumber,
  LinkCellRenderer,
  autoResize,
} from '@/helpers/renderHelpers';
import {
  handlerResponse
} from '@/helpers/commonHelpers';

export default {
  namespaced: true,
  state: {
    gridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      rowGroupPanelShow: 'always',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter(params) {
          return formatNumber(params.value, 5);
        },
        cellStyle(params) {
          return alignForNumber(params.value);
        }
      },
      components: {
        'PaymentLink': LinkCellRenderer('payment_id', '/payments/')
      },
      getRowStyle(params) {
        if (params.data.row_type === 'invoice') {
          return {'border-top': '2px solid #000', 'border-bottom': '2px solid #000', 'font-weight': 'bold'};
        }
        if (params.data.row_type === 'total') {
          return {'border-top': '2px solid #000', 'border-bottom': '1px solid #000', 'font-weight': 'bold'};
        }
        if (params.data.row_type === 'difference') {
          return {'border-top': '1px solid #000', 'border-bottom': '2px solid #000', 'font-weight': 'bold'};
        }
        return {}
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        }
      }
    },
    paymentsColumns: [
      {"field": "document_nr", colId: "document_nr", "headerName": "document", "cellRenderer": "PaymentLink"},
      {"field": "document_date", colId: "document_date", "headerName": "document_date"},
      {"field": "payment_date", colId: "payment_date", "headerName": "payment_date"},
      {"field": "payment_sum_str", colId: "payment_sum_str", "headerName": "payment_sum"},
      {
        "headerName": "document_sum", "children": [
        {"field": "document_sum_in_invoice_currency_str", colId: "document_sum_in_invoice_currency_str", "headerName": "official_abbr"},
        {"field": "document_additional_sum_str", colId: "document_additional_sum_str", "headerName": "additional_abbr"}
      ]
      },
      // {
      //   "headerName": "rate", "children": [
      //   {"field": "currencies_str", colId: "currencies_str", "headerName": "", "minWidth": 85},
      //   {"field": "currency_rate", colId: "currency_rate", "headerName": "", "minWidth": 85}
      // ]
      // },
      // {
      //   "headerName": "document_sum_base_curr", "children": [
      //   {"field": "document_sum_in_base_curr_str", colId: "document_sum_in_base_curr_str", "headerName": "official_abbr", "width": 80},
      //   {"field": "additional_sum_base_curr", colId: "additional_sum_base_curr", "headerName": "additional_abbr", "width": 80}
      // ]
      // },
      // {"field": "rate_difference_in_base_curr_str", colId: "rate_difference_in_base_curr_str", "headerName": "currency_rate_diff", "width": 125}
    ],
    payments: [],
    paymentsPinnedRowData: [],
    statuses: ["draft", "approved"],
    documents: [],
    comments: [],
  },
  getters: {
    paymentsGridOptions(state) {
      return {
        ...state.gridOptions,
        isExternalFilterPresent: () => true,
        doesExternalFilterPass: (params) => {
          const fields = state.paymentsColumns
            .filter(column => column.hasOwnProperty('field'))
            .map(column => column.field)
          return fields.some(field => field in params.data);
        }
      };
    }
  },
  mutations: {
    setCommentsList(state, data) {
      state.comments = data;
    },
    setDocumentsList(state, data) {
      state.documents = data;
    },
    setInvoicePayments(state, data) {
      state.payments = data.map(item => {
        if (item.row_type === 'difference') {
          item.additional_sum_base_curr = item.difference_additional_sum_str;
        } else {
          item.additional_sum_base_curr = item.document_additional_sum_str;
        }
        return item;
      });
    }
  },
  actions: {
    loadCommentsList(store, payload) {
      Vue.http.get(`accounting/sale_agent_invoices/${payload.id}/comments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setCommentsList', data);
        });
    },
    loadDocumentsList(store, payload) {
      Vue.http.get(`accounting/sale_agent_invoices/${payload.id}/attachments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setDocumentsList', data);
        });
    },
    async loadInvoicePayments(store, payload) {
      try {
        const response = await Vue.http.get(`accounting/sale_agent_invoices/${payload.id}/payment_transfers/`).then(handlerResponse);
        store.commit('setInvoicePayments', response);
      } catch (e) {
        console.log(e);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/agents/sales-invoices/salesAgentsInvoice.js